import React, { useEffect } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import { Clear } from "@mui/icons-material";

function DySelectBas({ selectValue, setSelectValue, lable, items }) {
  const handleChange = (event) => {
    const filed = event.target;
    setSelectValue(() => filed.value);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setSelectValue("00000000-0000-0000-0000-000000000000");
  };

  return (
    <FormControl
      sx={{
        width: "99%",
        margin: "0 4px",
        "& .MuiInputBase-formControl": { borderRadius: "4px" },
      }}
    >
      <InputLabel id="demo-simple-select-label">{lable}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={selectValue}
        label={lable}
        onChange={handleChange}
        input={
          <OutlinedInput
            label={lable}
            endAdornment={
              selectValue ? (
                <InputAdornment position="start">
                  <IconButton size="small" onClick={handleClear} edge="end">
                    <Clear sx={{ fontSize: 16 }} />
                  </IconButton>
                </InputAdornment>
              ) : null
            }
          />
        }
        sx={{
          "& .MuiSelect-outlined": { padding: "8px" },
        }}
      >
        {items?.map((item) => {
          return (
            <MenuItem key={item.key} value={item.value}>
              {item.key}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default DySelectBas;
